import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';

import classNames from 'classnames';
import productsData from '../data/products.json';
import { LazyLoadImage } from "react-lazy-load-image-component";
import Aos from "aos";
import "aos/dist/aos.css";
import ProductRangeLayout from './ProductRangeLayout';

const Product = ({ data, productId, index, showRangeDetails }) => {
    const { id } = useParams();
    const [showRange, setShowRange] = useState(id ? false : true);

    if (!showRange) {
        productId = id;
        data = productsData[productId];
        index = -1;
    }
    let styles = {
        bgColor: {
            backgroundColor: data.bgColor
        }
    };
    let buttonStyle = {
        width: 'fit-content'
    }

    if (productId === '103') {
        buttonStyle = {
            ...buttonStyle,
            border: '1px solid white'
        }
    };
    useEffect(() => {
        Aos.init({ duration: 700 });
    }, []);

    return (
        <>
            {
                data &&
                <div className='pb-1 lg:p-0'>
                    <div className={classNames('flex h-full lg:mx-0 lg:my-0 lg:m-0 shadow-xl lg:shadow-none lg:border-none border-slate-400 border flex-col', { 'lg:flex-row-reverse': index % 2 !== 0, 'lg:flex-row': (index % 2 === 0 || index === -1) })}>
                        <div className='lg:w-1/2'>
                            <LazyLoadImage className="lg:h-full object-cover w-full card-img landscape:hidden"
                                src={data.imageUrl}
                                alt=""
                            />
                            <LazyLoadImage className="lg:h-full object-cover w-full portrait:hidden"
                                src={data.imageUrl}
                                alt=""
                            />
                        </div>
                        <div className='lg:w-1/2 h-full lg:h-auto'>
                            <div className="py-4 px-4 lg:px-24 flex flex-col justify-start lg:justify-center text-left h-full w-full" style={styles.bgColor}>
                                <h2 data-aos="fade-up" className="text-white">
                                    {data.label}
                                </h2>
                                <p data-aos="fade-up" className="text-white pt-2 lg:pt-4">
                                    {data.description}
                                </p>
                                {
                                    showRange &&
                                    <div className='my-4 lg:my-8'>
                                        <button data-aos="fade-right" className="py-2 lg:py-4 lg:px-8  px-6 text-white rounded-full bg-dinshaw-theme text-sm lg:text-xl" style={buttonStyle} onClick={() => showRangeDetails(productId)}>Our Range</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        !showRange && data &&
                        <>
                            <ProductRangeLayout product={data}></ProductRangeLayout>
                        </>
                    }
                </div>
            }
        </>
    );
}

export default Product;